/**
 * Usage:
 *
 * Add a routeSync property to the component's options.
 * Example:
 *
 * routeSync: {
 *     query: {
 *         someParameter: { property: 'filter.someParameter', default: 'valueIfEmpty' },
 *         someOtherParameter: 'filter.someOtherParameter',
 *         someBooleanParameter: { property: 'filter.someBooleanParameter', type: 'bool' },
 *     }
 * }
 */

function iterateOptions(options, callback) {
    if (!options)
        return;

    for (let section of ['query', 'params']) {
        if (!options[section])
            continue;

        for (let key in options[section]) {
            let params = options[section][key];
            if (typeof params === 'string')
                params = { property: params };

            callback(section, key, params);
        }
    }
}

// Applies the route parameters to the VM
function applyRouteData(vm, route) {
    vm.navigating = true;

    iterateOptions(vm.$options.routeSync, (section, key, params) => {
        let fallback = (params.default === undefined) ? null : params.default;
        let value = route[section][key];
        value = (value === undefined) ? fallback : value;

        if (params.type && params.type == 'bool')
            value = (value == 'true' || value === true);

        _.set(vm, params.property, value);
    });

    Vue.nextTick(() => vm.navigating = false);
}

function maybeScheduleNavigate(routeSync) {
    if (this.navigating)
        return;

    this.needsNavigate = true;
    Vue.nextTick(navigate.bind(this));
}

function navigate() {
    if (!this.needsNavigate)
        return;

    let route = {
        query: JSON.parse(JSON.stringify(this.$route.query)),
        params: JSON.parse(JSON.stringify(this.$route.params)),
    }

    iterateOptions(this.$options.routeSync, (section, key, params) => {
        route[section][key] = _.get(this, params.property);
    });

    this.$router.push(route);

    this.needsNavigate = false;
}

const routeSync = {
    install(Vue, options) {
        Vue.mixin({
            data() {
                let data = {};
                iterateOptions(this.$options.routeSync, (section, key, params) => {
                    _.set(data, params.property, params.default);
                });
                return data;
            },
            created() {
                if (this.$options.routeSync) {
                    applyRouteData(this, this.$route);

                    iterateOptions(this.$options.routeSync, (section, key, params) => {
                        let callback = maybeScheduleNavigate;
                        if (params.debounce)
                            callback = _.debounce(callback, params.debounce);
                        this.$watch(params.property, callback);
                    });
                }
            },
            beforeRouteUpdate(to, from, next) {
                if (this.$options.routeSync)
                    applyRouteData(this, to);
                next();
            },
        });
    },
};

export default routeSync;
